import { updateApp } from "./store";

export function startPrep(){

    console.log(userColors) 
    getAppBackgroundColor(userColors.ultraLightColor)
    webAppStatusBarFill();

    // set functions
    window.GetFontClass = (iconFont) => {

        if (iconFont) {
            //default igenapps
            switch (iconFont.toLowerCase()) {
                case "kendoui":
                    return "km-kfont";
                case "igbasic":
                    return "km-igbasic";
                case "business":
                    return "km-igbusiness";
                case "food":
                    return "km-igfood";
                case "fun":
                    return "km-igfun";
                case "general":
                    return "km-iggeneral";
                case "general2":
                    return "km-iggeneral2";
                case "health-fitness":
                    return "km-ighealth";
                case "home":
                    return "km-ighome";
                case "location-weather":
                    return "km-iglocation";
                case "media":
                    return "km-igmedia";
                case "misc":
                    return "km-igmisc";
                case "transportation":
                    return "km-igtransport";
                case "igen-kit":
                case "igenkit":
                    return "km-igenkit";
                case "ss-symbolicons-line":
                    return "km-symbolicons";
                default:
                    return "km-igfont";
            }
    
        } else {
            //default igenapps
            return "km-igfont";
        }


    
    }
    

    window.getLang = (lang)=> {

        if (typeof lang === "undefined" || lang === null) {
            return "en";
        } else {
            if (lang.length > 3) {
                lang = lang.substring(0, 2);
            }
            switch (lang) {
                case "es":
                case "fr":
                case "pt":
                case "ru":
                case "cn":
                case "zh":
                case "id":
                case "it":
                case "de":
                case "jp":
                    break;
                case "ja":
                    lang = "jp";
                    break;
                default:
                    lang = "en";
            }
            return lang;
        }
    }
    

    window.ExternalRefOpen = (url)=> {
        //fix ios standalone webapp issue
        console.log('external click');
        console.log(nav.platform);
        console.log(idevice);
        if (idevice) {
            try {
                console.log('try click')
                //window.open(url);
                let a = document.createElement('a');
                a.id = 'urlclick'
                a.setAttribute("href", url);
                a.setAttribute("target", "_blank");
                let d = document.createEvent("HTMLEvents");
                d.initEvent("click", true, true);
                a.dispatchEvent(d);
                a = null;
            } catch (err) {
                console.log(err);
                window.open(url);
            }
        } else {
            console.log('no ios')
            window.open(url, "_blank");
        }
    
    }

    window.OpenInWebView = (url, title, isExternalAction)=> {
        const message = JSON.stringify({ url: url, title: title, isExternalAction: isExternalAction });
        FlutterWebview.postMessage(message);
    }

    if(!window.location.href.toLowerCase().includes('preview')){
        window.AppActiveTriggered = ()=> {
            if (document[hidden]) {
                console.log('hidden');
                appVisible = false;
                clearTimeout(versionTimer);
            } else {
                console.log('visible');
                appVisible = true;
                timer = 1;
                //start checks again
                versionTimer =setTimeout(CheckAppVersion(), 500);
            }
        }

        AppActive();
        timer = 1;
        CheckAppVersion();
    }
    
    function AppActive() {
    
        try {
            // Set the name of the hidden property and the change event for visibility
            console.log('Set page visibility check');
            if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
                hidden = "hidden";
                visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden";
                visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden";
                visibilityChange = "webkitvisibilitychange";
            }
    
            document.addEventListener(visibilityChange,AppActiveTriggered
             , false);
            console.log('page visibility event set');
        } catch(err){
            console.log('page visibility event set'+ err);
        }
    }
    
    function CheckAppVersion() {
        if (timer === 1) {
            fetch('/app/getappversion?appid=' + appId).then((req)=> req.json()).then((data)=>{
                if (data) {
                    if (userAppVersion < data) {
                        updateApp.set(true);
                        timer=0;
                    } else {
                        timer = 3;
                        console.log('waiting ' + timer * 5 + ' seconds more before refresh check');
                        if (appVisible)
                        versionTimer =setTimeout(CheckAppVersion, 5000);
                    }
                }
            })
        } else {
            timer--;
            console.log('waiting ' + timer * 5 + ' seconds more before refresh check');
            if (appVisible)
            versionTimer = setTimeout(()=>CheckAppVersion(), 5000);
        }
    }
            
    function AppHeader(){
        if (idevice) {

            var nver = getParameterByName("native");
    
            if (pg &&  nver > 700) {
            
    
                if (screen.width === 375 && screen.height > 700) {
    
                        //app drawer
                
                    console.log(nver);
                    if (nver === "901") {
                        //$(document.body).append("<style>.km-navbar{margin-top:0px!important;} .km-content{padding-bottom:40px!important;} #app-drawer ul{margin-top:0px!important} .km-material #igenapps-menu-tab.km-tabstrip{height:70px;max-height:70px;padding-bottom:20px!important}</style>");
                        console.log('navbar update for 901');
                    } else {
                        //$(document.body).append("<style>.km-navbar{margin-top:40px!important;} .km-content{padding-bottom:40px!important;} #app-drawer ul{margin-top:40px!important} .km-material #igenapps-menu-tab.km-tabstrip{height:70px;max-height:70px;padding-bottom:20px!important}</style>");
    
                    }
                    console.log('navbar fix ios iphonex applied');
                } else {
    
    
                    if (screen.width === 414) {
                        if (nver === "901") {
                            //$(document.body).append("<style>.km-navbar{margin-top:0px!important;} #app-drawer ul{margin-top:0px!important}</style>");
    
                        } else {
                            //$(document.body).append("<style>.km-navbar{margin-top:30px!important;} #app-drawer ul{margin-top:30px!important}</style>");
                        }
                        console.log('navbar fix ios11 applied iphone plus');
    
                    } else {
                        if (nver === "901") {
                            //$(document.body).append("<style>.km-navbar{margin-top:0px!important;} #app-drawer ul{margin-top:0px!important}</style>");
    
                        } else {
                            //$(document.body).append("<style>.km-navbar{margin-top:20px!important;} #app-drawer ul{margin-top:20px!important}</style>");
                        }
                        console.log('navbar fix ios applied w:' + screen.width + ' h:' + screen.height);
                    }
                }
                
                
            } else {
    
                if ((screen.width === 375 || screen.width === 390 || screen.width === 414 || screen.width === 428) && screen.height > 700 && menuType === 'tabs' && !CheckFlutter()) {
                    //iphonex tab fix
                    //$(document.body).append("<style>.km-material #igenapps-menu-tab.km-tabstrip{height:70px;max-height:70px;padding-bottom:20px!important}</style>");
                    console.log('tabbar fix ios iphonex+ applied');
                } 
    
            }
            
        }
    }    

}
    


function webAppStatusBarFill(){

    document.body.classList.remove('basic-color-background');

    // if (window.matchMedia('(display-mode: standalone)').matches && idevice && !pg) {
    //     console.log("This is running as standalone.");

    //     document.body.style.backgroundColor = userColor;
    //     document.body.classList.remove('.basic-color-background');

    //     if ((screen.width === 375 || screen.width === 390) && screen.height > 700) {
    //         document.body.style.transform ='translate3d(0, 20px, 0)';
    //         console.log('pwa navbar fix ios iphonex applied');
    //     } else {
    //         if (screen.width === 414 || screen.width ===  428 ) {

    //             document.body.style.transform ='translate3d(0, 20px, 0)';
    //             console.log('pwa navbar fix applied iphone plus');
    //         } else {
    //             document.body.style.transform ='translate3d(0, 20px, 0)';
    //             console.log('navbar fix ios applied w:' + screen.width + ' h:' + screen.height);
    //         }
    //     }
    // }
}

export function checkIframeURL(urlhost) {
    let result = false;
    if (localStor) {
        if (localStorage.getItem("iframeURLS")) {

            let urls = JSON.parse(localStorage.getItem("iframeURLS"));

            if (checkArray(urls, urlhost)) {
                result = true;
            }

        }
    }
    return result;
}

function checkArray(arr, obj) {
    return arr.indexOf(obj) !== -1;
}
export function checkWindowURL(urlhost) {
    let result = false;
    if (localStor) {
        if (localStorage.getItem("windowURLS")) {

            let urls = JSON.parse(localStorage.getItem("windowURLS"));

            if (checkArray(urls, urlhost)) {
                result = true;
            }

        }
    }
    return result;
}
export function AddURLResult(urlhost) {
    if (localStor) {
        let urls = localStorage.getItem("iframeURLS");

        if (urls !== null) {

            urls = JSON.parse(localStorage.getItem("iframeURLS"));

            if (!checkArray(urls, urlhost)) {
                urls.push(urlhost);
            }
        } else {
            urls = new Array();
            urls[0] = urlhost;
        }

        localStorage.setItem("iframeURLS", JSON.stringify(urls));
    }
}
export function AddURLResultWindow(urlhost) {
    if (localStor) {
        let urls = localStorage.getItem("windowURLS");

        if (urls !== null) {

            urls = JSON.parse(localStorage.getItem("windowURLS"));

            if (!checkArray(urls, urlhost)) {
                urls.push(urlhost);
            }
        } else {
            urls = new Array();
            urls[0] = urlhost;
        }

        localStorage.setItem("windowURLS", JSON.stringify(urls));
    }
}
export async function  iframeCheck(url){
    const req = await fetch('/Feed/iFrameCheck?url=' + encodeURI(url)); 
	const result = await req.json();

    return result
}

export async function checkUrls(urls){

    if(urls && urls.length >0){

        urls.forEach(async url => {
            if(url.includes('http')){
                if(!checkIframeURL(url)&& !checkWindowURL(url)){
                    if( await iframeCheck(url)){
                        AddURLResult(url)
                    }else{
                        AddURLResultWindow(url);
                    }
                } 
            }
        });
    }
}

export async function checkDataForUrls(data,template){
    console.log('checking for urls '+ template)
    try{
        const urls=[];

        if(template.includes('list') && !template.includes("menu")){
            
            if(data.rows && data.rows !== undefined && data.rows.length > 0){
                data = data.rows;
            } 
        }

        if(data){
            if(Array.isArray(data)){

                data.forEach(link => {
                    getUrl(link,urls)
                });

            }else{
                getUrl(data,urls)
            }

            if(urls.length>0){
                console.log('check urls');
                console.log(urls);
                checkUrls(urls);
            }
        }
    }
    
    catch(err){
        console.log('url parsing err')
        console.log(err)
    }
}

function getUrl(link,urls){

    //console.log('check url');
    //console.log(link);

    if(link.value && link.value._class && link.value._class.toLowerCase().includes('action')){
        if(link.value.url && link.value.url !== undefined){
            if(!urls.includes(link.value.url))
            urls.push(link.value.url)
        }     
    }

    if(link.link && link.link.value && link.link.value._class && link.link.value._class.toLowerCase().includes('action')){
        if(link.link.value.url && link.link.value.url !== undefined){
            if(!urls.includes(link.link.value.url))
            urls.push(link.link.value.url)
        }     
    }
}

function getAppBackgroundColor(color) {
    console.log('prep background color '+color)
    const canvas = document.getElementById("color-canvas");
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, 1, 1);
    const img = new Image;
    img.onload = function () {
        ctx.drawImage(img, 0, 0, 1, 1);
        const p = ctx.getImageData(0, 0, 1, 1).data;
        const hex = "#" + ("000000" + rgbToHex(p[0], p[1], p[2])).slice(-6);

        appBackground = { rgbBackground: 'rgba(' + p[0] + ',' + p[1] + ',' + p[2] + ',0)', hexBackground: hex }
        console.log(appBackground);
    };

    img.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABl0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC4xMzQDW3oAAAANSURBVBhXY/j3798dAAnPA9eweMWuAAAAAElFTkSuQmCC";

    function rgbToHex(r, g, b) {
        if (r > 255 || g > 255 || b > 255)
            throw "Invalid color component";
        return ((r << 16) | (g << 8) | b).toString(16);
    }
}

